import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default () => {
    return new Vuex.Store({
        state: {
            participants: [],
            pubChannel: '',
            myself: {}
        },
        mutations: {
            setParticipants (state, data) {
              state.participants = data
            },
            setPubChannel: (state, channel) => {
                // console.log('setting pub channel: ', channel)
                state.pubChannel = channel
            },
            saveMyself: (state, myself) => {
                state.myself = myself
            },
        },
        actions: {},
        getters: {
            getParticipantById: (state) => (id) => {
                let curr_participant;
                state.participants.forEach(participant => {
                    if (participant.id === id) {
                        curr_participant = participant;
                    }
                });

                return curr_participant;
            },
        }
    })
}
